import type { GetStartedData } from "./GetStartedFlow";
import { buildManageSummary, buildPackageSummary } from "./pricing";

const API_URL = process.env.NEXT_PUBLIC_DASHBOARD_API_URL;

/**
 * Sends the finished get-started flow to the dashboard backend, which saves the request and creates
 * a Whop checkout for it. The dashboard account and login email come only after the payment.
 *
 * Resolves with the checkout link to send the customer to, or null when nothing is due (their
 * account is then created straight away). Throws with a message fit to show them.
 */
export async function submitGetStarted(data: GetStartedData): Promise<{ checkoutUrl: string | null }> {
  // TEMP: the API call is switched off for now, so the form skips straight to the confirmation
  // screen without saving anything or starting a checkout. Remove this line and uncomment below.
  return { checkoutUrl: null };

  /*
  if (!API_URL) throw new Error("Registration is temporarily unavailable. Please try again later.");
  if (!data.serviceId) throw new Error("Please choose a service first.");

  const summary =
    data.serviceId === "manage-existing-business"
      ? buildManageSummary(data)
      : buildPackageSummary(data);

  // The contact details and service travel as their own fields; the rest are the flow's answers.
  const { serviceId, contactName, contactEmail, contactPhone, ...answers } = data;

  let res: Response;
  try {
    res = await fetch(`${API_URL}/api/v1/public/formation-requests`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name: contactName.trim(),
        email: contactEmail.trim(),
        phone: contactPhone.trim(),
        serviceType: serviceId,
        answers,
        summary,
      }),
    });
  } catch {
    throw new Error("We couldn't reach our servers. Check your connection and try again.");
  }

  const body = (await res.json().catch(() => ({}))) as { error?: string; checkoutUrl?: string | null };
  if (!res.ok) throw new Error(body.error || "Something went wrong. Please try again.");
  return { checkoutUrl: body.checkoutUrl ?? null };
  */
}
